/**
 * Fires `browser:back` / `browser:forward` when the customer uses browser history buttons.
 *
 * @example
 * document.addEventListener('browser:back', (event) => {
 *   console.log(event.detail.direction, event.detail.url);
 * });
 */
(function browserBackEvent() {
  const BACK_EVENT = 'browser:back';
  const FORWARD_EVENT = 'browser:forward';
  const INDEX_KEY = '__navIndex';

  
  /**
   * @param {unknown} state
   * @returns {number | null}
   */
  function getIndex(state) {
    if (state && typeof state === 'object' && INDEX_KEY in state) {
      const value = /** @type {{ __navIndex?: unknown }} */ (state)[INDEX_KEY];
      if (typeof value === 'number') return value;
    }
    return null;
  }

  /**
   * @param {unknown} state
   * @param {number} navIndex
   */
  function withIndex(state, navIndex) {
    if (state != null && typeof state === 'object' && !Array.isArray(state)) {
      return Object.assign({}, state, { [INDEX_KEY]: navIndex });
    }
    return { [INDEX_KEY]: navIndex, __value: state };
  }

  const storedIndex = getIndex(history.state);
  /** @type {number} */
  let index = storedIndex == null ? 0 : storedIndex;
  if (storedIndex == null) {
    history.replaceState(withIndex(history.state, index), '');
  }

  const originalPushState = history.pushState.bind(history);
  const originalReplaceState = history.replaceState.bind(history);

  history.pushState = function (state, title, url) {
    index += 1;
    return originalPushState(withIndex(state, index), title, url);
  };

  history.replaceState = function (state, title, url) {
    return originalReplaceState(withIndex(state, index), title, url);
  };

  /**
   * @param {'back' | 'forward'} direction
   * @param {'popstate' | 'back_forward' | 'bfcache'} source
   */
  function fire(direction, source) {
    const eventName = direction === 'forward' ? FORWARD_EVENT : BACK_EVENT;

    document.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true,
        detail: {
          direction,
          source,
          url: location.href,
          referrer: document.referrer,
        },
      })
    );

  }

  window.addEventListener('popstate', function (event) {
    const nextIndex = getIndex(event.state);
    const direction = nextIndex != null && nextIndex > index ? 'forward' : 'back';
    index = nextIndex != null ? nextIndex : Math.max(0, index - 1);
    fire(direction, 'popstate');
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fire('back', 'bfcache');
  });

  const nav = performance.getEntriesByType('navigation')[0];
  if (nav instanceof PerformanceNavigationTiming && nav.type === 'back_forward') {
    fire('back', 'back_forward');
  }
})();
